import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=43eaf2b6&scoped=true&"
import script from "./SidebarLayout.vue?vue&type=script&lang=js&"
export * from "./SidebarLayout.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLayout.vue?vue&type=style&index=0&id=43eaf2b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eaf2b6",
  null
  
)

export default component.exports